// DESCRIPTION: Attributes related models & functions

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, ) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.AttributesParse = this.HyperMD.AttributesParse || {}), );
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var NodeType;
    (function (NodeType) {
        NodeType[NodeType["QUOTED_STRING"] = 0] = "QUOTED_STRING";
        NodeType[NodeType["WORD"] = 1] = "WORD";
        NodeType[NodeType["ARRAY"] = 2] = "ARRAY";
    })(NodeType || (NodeType = {}));
    /**
     * Parses block attributes
     * @param text e.g. {#identifier .class1 .class2 key1=value1 key2=value2}
     */
    function default_1(text) {
        // remove surrounding { } if exist
        var textToParse = (text || "").trim();
        if (textToParse[0] === "{" && textToParse[textToParse.length - 1] === "}") {
            textToParse = textToParse.slice(1, -1);
        }
        var output = {};
        var pendingKey;
        var i = 0;
        while (i < textToParse.length) {
            var node = extractArray(textToParse, i) ||
                extractQuotedString(textToParse, i) ||
                extractWord(textToParse, i);
            if (node) {
                var keyIsPending = typeof pendingKey === "string";
                var rawValue = node[0], subEnd = node[1], nodeType = node[2];
                var value = nodeType === NodeType.WORD && keyIsPending
                    ? extractValue(rawValue)
                    : rawValue;
                i = subEnd;
                if (keyIsPending) {
                    output[pendingKey] = value;
                    pendingKey = undefined;
                }
                else if (textToParse[i] === "=") {
                    pendingKey = value;
                }
                else {
                    var firstChar = value[0];
                    var specialAttribute = void 0;
                    switch (firstChar) {
                        case ".":
                            specialAttribute = "class";
                            break;
                        case "#":
                            specialAttribute = "id";
                            break;
                    }
                    if (specialAttribute) {
                        var specialValue = value.substring(1);
                        if (specialValue.length) {
                            var previousValue = output[specialAttribute];
                            output[specialAttribute] =
                                typeof previousValue === "undefined"
                                    ? specialValue
                                    : previousValue + " " + specialValue;
                        }
                    }
                    else {
                        if (typeof value === "string") {
                            output[value] = true;
                        }
                    }
                }
            }
            else {
                // just skipping one character if it is not known for soft error handling
                i += 1;
            }
        }
        return output;
    }
    exports.default = default_1;
    function extractQuotedString(text, start) {
        var quote = text[start];
        if (!"'\"`".includes(quote)) {
            return;
        }
        var end = start + 1;
        var chars = [];
        while (end < text.length) {
            if (text[end] === "\\") {
                if (end + 1 < text.length) {
                    chars.push(text[end + 1]);
                }
                end += 2;
                continue;
            }
            if (text[end] === quote) {
                end += 1;
                break;
            }
            chars.push(text[end]);
            end += 1;
        }
        return [chars.join(""), end, NodeType.QUOTED_STRING];
    }
    var wordCharRegExp = /^[^,;=\s]$/;
    function extractWord(text, start) {
        var i = start;
        var bracketDepth = 0;
        while (i < text.length) {
            var char = text[i];
            if (!wordCharRegExp.test(char)) {
                break;
            }
            if (char === "[") {
                bracketDepth += 1;
            }
            else if (char === "]") {
                bracketDepth -= 1;
            }
            if (bracketDepth < 0) {
                break;
            }
            i += 1;
        }
        if (i === start) {
            return;
        }
        return [text.substring(start, i), i, NodeType.WORD];
    }
    function extractArray(text, start) {
        if (text[start] !== "[") {
            return;
        }
        var result = [];
        var i = start + 1;
        while (i < text.length) {
            var char = text[i];
            if (char === "]") {
                i += 1;
                break;
            }
            var node = extractArray(text, i) ||
                extractQuotedString(text, i) ||
                extractWord(text, i);
            if (node) {
                var rawValue = node[0], subEnd = node[1], nodeType = node[2];
                var value = nodeType === NodeType.WORD ? extractValue(rawValue) : rawValue;
                i = subEnd;
                result.push(value);
            }
            else {
                i += 1;
            }
        }
        return [result, i, NodeType.ARRAY];
    }
    function extractValue(value) {
        // boolean
        if (value.toLowerCase() === "true") {
            return true;
        }
        else if (value.toLowerCase() === "false") {
            return false;
        }
        else if (!isNaN(value)) {
            // number
            return parseFloat(value);
        }
        return value;
    }
});
